import { commonUtils } from '@/helpers/commonUtils'
import {
  FREE_BENEFITS,
  MAX_BENEFITS,
  PRO_BENEFITS,
  PRO_V_BENEFITS,
  VIP_GIFT_LIST,
} from '@/pages/PricingPage/pricingConsts'
import { userService } from '@/services/userService'
import cls from 'classnames'
import { observer } from 'mobx-react'
import { CSSProperties, useState } from 'react'
import { WelfareCountDownBox } from '../WelfareCountDownBox'
import style from './NewUserDiscount.module.less'

// export interface Plan extends ServerDataTypes.VipPlan {
//   priceStr: string
//   originalPrice: string
//   perPrice: string
//   id: string
//   offCount: number
// }

type NewUserDiscountProps = {
  discountEndTime: number
  discount: ServerDataTypes.FormatPlan
  styleCSS?: CSSProperties
  onSkipClick: () => void
  onJoinClick: () => void
  onTimerEnd?: () => void
}

export const NewUserDiscount = observer((props: NewUserDiscountProps) => {
  const { discount, discountEndTime, styleCSS, onSkipClick, onJoinClick, onTimerEnd } = props

  const [showCountdown, setShowCountdown] = useState(true)

  const getUserRecordStr = (str: string) => {
    return `${str}_B`
  }

  const changePlan = () => {
    onTimerEnd?.()
    setShowCountdown(false)
  }

  const discountVersion = discount.version
  let title = ''
  if (discountVersion === 'pro') {
    title = 'PRO版'
  } else if (discountVersion === 'pro+') {
    title = '无限版'
  } else if (discountVersion === 'max') {
    title = 'Max版'
  }

  let tokenStr = '1,000,000/月'

  if (discountVersion === 'pro') {
    tokenStr = PRO_BENEFITS.tokenCount + '/月'
  } else if (discountVersion === 'pro+') {
    tokenStr = PRO_V_BENEFITS.tokenCount + '/月'
  } else if (discountVersion === 'max') {
    tokenStr = MAX_BENEFITS.tokenCount + '/月'
  }

  const isProPlusOrMax = discountVersion === 'pro+' || discountVersion === 'max'

  return (
    <section className={cls(style.discountBoxPlanB, 'col-1', 'flex-row')} style={{ ...styleCSS }}>
      <p className={style.title}>
        Hi~欢迎注册「会译」，我们为你准备了「{title}
        」新人专属福利
        <img
          className={style.titleBg}
          src='https://assets.weibanzhushou.com/web/pt-web/login-page_giftPlanB_bg__title.b93b86f063f1.png'
        />
        <div className={cls(style.discount)}>立享{discount.discountPercent}折优惠</div>
      </p>

      <div className={cls('flex-row', 'align-side', 'justify-center', style.center)}>
        <div className={style.left}>
          <p className={cls(style.title, 'flex-row', 'align-center', 'justify-center')}>
            <img
              className={style.icon}
              src='https://assets.weibanzhushou.com/web/pt-web/login-page_giftPlanB_icon__free.f74d9d35dae0.png'
            />
            <span>免费版</span>
          </p>
          <div className={cls(style.freeCountArea)}>
            <img
              className={cls(style.icon)}
              src={commonUtils.getStaticFile('login/icon__free-text.png')}
            />
            <div className={cls(style.line)}>
              <div className={cls(style.item)}>
                <p className={cls(style.count)}>{FREE_BENEFITS.tokenCount}/天</p>
                <span className={cls(style.desc)}>高级模型Token</span>
              </div>
              <div className={cls(style.item)}>
                <p className={cls(style.count)}>{FREE_BENEFITS.pdfProPageCount}页/天</p>
                <span className={cls(style.desc)}>PDF页数</span>
              </div>
            </div>

            <div className={cls(style.line)} style={{ marginTop: '16px' }}>
              <div className={cls(style.item)}>
                <p className={cls(style.count)}>5次</p>
                <span className={cls(style.desc)}>Chat次数</span>
              </div>
              <div className={cls(style.item)}>
                <p className={cls(style.count)}>5次</p>
                <span className={cls(style.desc)}>图片翻译次数</span>
              </div>
            </div>
          </div>

          <div className={cls(style.freeWrap)}>
            <div className={cls(style.translate)}>
              <img
                className={cls(style.tag)}
                src={commonUtils.getStaticFile('login/icon__translate.png')}
              />

              <img
                className={cls(style.tagRight)}
                src={commonUtils.getStaticFile('login/free_right-tag.png')}
              />

              <div className={cls(style.line)}>
                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__free-web.png')}
                  />
                  <p className={cls(style.text)}>网页翻译</p>
                </div>

                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__free-select.png')}
                  />
                  <p className={cls(style.text)}>划词翻译</p>
                </div>
              </div>

              <div className={cls(style.line)}>
                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__free-pdf.png')}
                  />
                  <p className={cls(style.text)}>PDF翻译</p>
                </div>

                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__free-realtime.png')}
                  />
                  <p className={cls(style.text)}>即时翻译</p>
                </div>
              </div>

              <div className={cls(style.line)}>
                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__free-video.png')}
                  />
                  <p className={cls(style.text)}>视频翻译</p>
                </div>

                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__free-image.png')}
                  />
                  <p className={cls(style.text)}>图片翻译</p>
                </div>
              </div>
            </div>

            <div className={cls(style.summary)}>
              <img
                className={cls(style.tag)}
                src={commonUtils.getStaticFile('login/icon__summary.png')}
              />

              <div className={cls(style.line)}>
                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/word-highlight-free.png')}
                  />
                  <p className={cls(style.text)}>生词高亮</p>
                </div>

                <div className={cls(style.item)} style={{ marginLeft: '57px' }}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/collect-free.png')}
                  />
                  <p className={cls(style.text)}>内容收藏</p>
                </div>
              </div>

              <div className={cls(style.line)}>
                <div className={cls(style.item)}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__summary-video.png')}
                  />
                  <p className={cls(style.text)}>网页/视频总结</p>
                </div>

                <div className={cls(style.item)} style={{ marginLeft: '27px' }}>
                  <img
                    className={cls(style.icon)}
                    src={commonUtils.getStaticFile('login/icon__summary-focus.png')}
                  />
                  <p className={cls(style.text)}>信息聚焦</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className={cls(style.right, {
            [style.proPlus]: isProPlusOrMax,
          })}
        >
          <div className={cls(style.banner)}>
            <img
              src='https://assets.weibanzhushou.com/web/pt-web/buy-vip-dialog/banner-text.png'
              className={cls(style.bannerText)}
            />
          </div>

          <div
            className={cls(style.rightContent, 'flex-row', 'align-side', {
              [style.proPlus]: isProPlusOrMax,
            })}
          >
            <div className={style.left}>
              <div
                className={cls(style.proCountArea, {
                  [style.proPlus]: isProPlusOrMax,
                })}
              >
                <div className={cls(style.line)}>
                  <div
                    className={cls(style.item, {
                      [style.proPlus]: isProPlusOrMax,
                    })}
                  >
                    <p className={cls(style.count)}>{tokenStr}</p>
                    <span className={cls(style.desc)}>高级模型Token</span>
                  </div>
                  <div
                    className={cls(style.item, {
                      [style.proPlus]: isProPlusOrMax,
                    })}
                  >
                    <p className={cls(style.count)}>
                      {discountVersion === 'pro'
                        ? `${PRO_BENEFITS.pdfProPageCount}页/月`
                        : `${PRO_V_BENEFITS.pdfProPageCount}页/月`}
                    </p>
                    <span className={cls(style.desc)}>PDF页数</span>
                  </div>
                </div>

                <div className={cls(style.line)} style={{ marginTop: '16px' }}>
                  <div
                    className={cls(style.item, {
                      [style.proPlus]: isProPlusOrMax,
                    })}
                  >
                    <p className={cls(style.count)}>
                      {discountVersion === 'pro' ? '1000次/月' : '无限'}
                    </p>
                    <span className={cls(style.desc)}>Chat次数</span>
                  </div>
                  <div
                    className={cls(style.item, {
                      [style.proPlus]: isProPlusOrMax,
                    })}
                  >
                    <p className={cls(style.count)}>
                      {discountVersion === 'pro' ? '100张/月' : '1000张/月'}
                    </p>
                    <span className={cls(style.desc)}>图片翻译次数</span>
                  </div>
                </div>
              </div>

              <div
                className={cls(style.wrap, {
                  [style.proPlus]: isProPlusOrMax,
                })}
              >
                <div className={cls(style.translate)}>
                  <img
                    className={cls(style.tag)}
                    src={commonUtils.getStaticFile(
                      discountVersion === 'pro' ? 'login/tag-ai.png' : 'login/tag-ai-pro-plus.png'
                    )}
                  />
                  <img
                    className={cls(style.tagRight)}
                    src={commonUtils.getStaticFile(
                      discountVersion === 'pro'
                        ? 'login/pro-right-tag.png'
                        : 'login/pro-plus-right-tag.png'
                    )}
                  />

                  <div className={cls(style.line)}>
                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-web.png')}
                      />
                      <p className={cls(style.text)}>网页翻译</p>
                    </div>

                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-select.png')}
                      />
                      <p className={cls(style.text)}>划词翻译</p>
                    </div>
                  </div>

                  <div className={cls(style.line)}>
                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-pdf.png')}
                      />
                      <p className={cls(style.text)}>PDF翻译</p>
                    </div>

                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-realtime.png')}
                      />
                      <p className={cls(style.text)}>即时翻译</p>
                    </div>
                  </div>

                  <div className={cls(style.line)}>
                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-video.png')}
                      />
                      <p className={cls(style.text)}>视频翻译</p>
                    </div>

                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-image.png')}
                      />
                      <p className={cls(style.text)}>图片翻译</p>
                    </div>
                  </div>
                </div>

                <div
                  className={cls(style.summary, {
                    [style.proPlus]: isProPlusOrMax,
                  })}
                >
                  <img
                    className={cls(style.tag)}
                    src={commonUtils.getStaticFile(
                      discountVersion === 'pro' ? 'login/tag-read.png' : 'login/tag-read-plus.png'
                    )}
                  />

                  <div className={cls(style.line)}>
                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/word-highlight.png')}
                      />
                      <p className={cls(style.text)}>生词高亮</p>
                    </div>

                    <div className={cls(style.item)} style={{ marginLeft: '54px' }}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/collect-vip.png')}
                      />
                      <p className={cls(style.text)}>内容收藏</p>
                    </div>
                  </div>

                  <div className={cls(style.line)}>
                    <div className={cls(style.item)}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-summary-video.png')}
                      />
                      <p className={cls(style.text)}>网页/视频总结</p>
                    </div>

                    <div className={cls(style.item)} style={{ marginLeft: '24px' }}>
                      <img
                        className={cls(style.icon)}
                        src={commonUtils.getStaticFile('login/pro-summary-focus.png')}
                      />
                      <p className={cls(style.text)}>信息聚焦</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={cls(style.right, {
                [style.proPlus]: isProPlusOrMax,
              })}
            >
              <div className={style.giftBox}>
                <div className={cls(style.title)}>
                  <p
                    className={cls(style.text, {
                      [style.proPlusText]: isProPlusOrMax,
                    })}
                  >
                    年费会员还可领取价值千元的礼包
                  </p>
                  <img
                    className={style.bgGiftTitle}
                    src={
                      discountVersion === 'pro'
                        ? 'https://assets.weibanzhushou.com/web/pt-web/login-page_giftPlanB_bg__right-title.571aeb1c6e85.png'
                        : commonUtils.getStaticFile('login/gift_underline_plus.png')
                    }
                  />
                </div>
                <div className={style.giftList}>
                  {VIP_GIFT_LIST.map((item, index) => {
                    return (
                      <div key={index} className={cls(style.giftItem, style.flexCol)}>
                        <img src={discount.version === 'pro' ? item.planBIcon : item.proPlusIcon} />
                        <span className={style.giftName}>{item.name}</span>
                        <span className={style.giftDesc}>{item.desc}</span>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={cls(style.bottom, 'flex-row', 'align-center')}>
        <div className={style.priceBox}>
          <div className={cls('flex-row', 'justify-end')}>
            <span className={style.price}>{discount?.price}</span>
            <span className={style.unit}>元/{discount.unitDesc}</span>
            <div className={style.saleIcon}>立享{discount.discountPercent}折优惠</div>
          </div>
          {discount.timeType === 'year' && (
            <div className={style.priceDesc}>
              <p className={style.currentPrice}>{discount.unitPrice}元/月</p>
              <p className={style.originalPrice}>原价{discount.originPrice}元/年</p>
            </div>
          )}
        </div>
        <div className={style.btnBox}>
          {showCountdown && (
            <WelfareCountDownBox
              prefixText={`${discount.discountPercent}折福利即将失效`}
              className={style.countdownBox}
              end={discountEndTime!}
              timeEnd={() => {
                changePlan()
              }}
            ></WelfareCountDownBox>
          )}
          <button
            className={cls(style.payBtn, {
              [style.proPlus]: isProPlusOrMax,
            })}
            onClick={() => {
              userService.trackUserRecord(getUserRecordStr('click_new_user_discount_pay_w'))
              onJoinClick()
            }}
          >
            <div className={cls(style.now)}>
              即刻拥有
              <img
                src='https://assets.weibanzhushou.com/web/pt-web/login-page_icon__arrow-right.e1252da981ac.png'
                className={style.iconArrowRight}
              />
            </div>
            {/* <p className={cls(style.text)}>3天无理由100%退款</p> */}
          </button>
        </div>
        <span
          className={style.jump}
          onClick={() => {
            userService.trackUserRecord(getUserRecordStr('click_new_user_discount_jump_w'))
            onSkipClick()
          }}
        >
          跳过
        </span>
      </div>
    </section>
  )
})
